export default "__VITE_ASSET__Dwm7Tg_m__"